import { cn } from 'cn';
import { type ReactNode } from 'react';

import { Icon } from './Icon';

type P = {
  readonly avatar?: ReactNode;
  readonly displayName: string;
  readonly email?: string;
  readonly position?: string;
} & ComponentStyling;

/**
 * A user's name and position beside the avatar in a header band, with the
 * contact details underneath. A line with no value is left out, and so is
 * the e-mail row when the address already is the display name.
 */
export const UserDetails = ({
  avatar,
  className,
  displayName,
  email,
  position,
  style,
}: P) => (
  <div className={cn('flex flex-col', className)} style={style}>
    <div className="flex items-start gap-3 bg-tiga-surface-off-white px-4 pt-4 pb-3">
      {avatar}
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="text-sm font-semibold wrap-break-word">
          {displayName}
        </span>
        {position ? (
          <span className="text-xs wrap-break-word text-tiga-text-lighter">
            {position}
          </span>
        ) : null}
      </div>
    </div>
    {email && email !== displayName ? (
      <div className="flex flex-col gap-2 px-4 py-3">
        <a
          className="flex min-w-0 items-center gap-2.5 text-xs text-tiga-action-default hover:underline"
          href={`mailto:${email}`}
        >
          <Icon
            className="text-tiga-text-lighter"
            metaphor="emailOutlined"
            size="sm"
          />
          <span className="min-w-0 wrap-break-word">{email}</span>
        </a>
      </div>
    ) : null}
  </div>
);
